/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateWhatsAppIndex } from '../../axios/candidateWhatsAppIndex'
import type {
	CandidateWhatsAppIndexError,
	CandidateWhatsAppIndexPathParams,
	CandidateWhatsAppIndexResponse,
} from '../../types/CandidateWhatsAppIndex'

export const candidateWhatsAppIndexQueryKey = (candidateId: CandidateWhatsAppIndexPathParams['candidateId']) =>
	[{ url: '/candidates/:candidateId/whatsapp', params: { candidateId } }] as const

export type CandidateWhatsAppIndexQueryKey = ReturnType<typeof candidateWhatsAppIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::index */
export function candidateWhatsAppIndexQueryOptions(
	candidateId: CandidateWhatsAppIndexPathParams['candidateId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateWhatsAppIndexResponse,
		AxiosError<CandidateWhatsAppIndexError>,
		CandidateWhatsAppIndexResponse,
		CandidateWhatsAppIndexQueryKey
	>({
		queryKey: candidateWhatsAppIndexQueryKey(candidateId),
		queryFn: ({ signal }) => candidateWhatsAppIndex(candidateId, { signal, ...config }).then(res => res.data),
		enabled: !!candidateId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::index */
export function useCandidateWhatsAppIndex<TSelectData = CandidateWhatsAppIndexResponse>(
	candidateId: CandidateWhatsAppIndexPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateWhatsAppIndexResponse,
					AxiosError<CandidateWhatsAppIndexError>,
					TSelectData,
					CandidateWhatsAppIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateWhatsAppIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateWhatsAppIndexQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::index */
export function useCandidateWhatsAppIndexSuspense<TSelectData = CandidateWhatsAppIndexResponse>(
	candidateId: CandidateWhatsAppIndexPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateWhatsAppIndexResponse,
					AxiosError<CandidateWhatsAppIndexError>,
					TSelectData,
					CandidateWhatsAppIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateWhatsAppIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateWhatsAppIndexQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
